// extracted by mini-css-extract-plugin
export var icon = "_79-1";
export var subtext = "_79-0";